import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import styles from './style.module.css';

export function VoucherCollectListSkeleton() {
  return <Skeleton variant="rect" width="100%" height={50} />;
}

export default function ProductDetailLoading({ isLogin = false }) {
  return (
    <Container className={styles.containerLoading}>
      {isLogin ? (
        <>
          <Grid container spacing={3} className={styles.wrapper}>
            <Grid item xs={12} lg={4}>
              <Skeleton variant="rect" width="100%" height={330} />
              <Skeleton variant="text" width="100%" height={50} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={8}>
              <Skeleton variant="rect" width={596} height={26} />
              <Skeleton variant="rect" width={500} height={26} />
              <Skeleton variant="text" width={100} height={16} />
              <Skeleton variant="rect" width={500} height={26} />
              <Skeleton variant="rect" width={500} height={26} />
              <Skeleton variant="rect" width="100%" height={362} />
              <Skeleton variant="rect" width="100%" height={362} />
            </Grid>
          </Grid>
          {Array.from({ length: 2 }).map((_, index) => (
            <Grid key={index} container spacing={3} className={styles.wrapper}>
              <Grid item xs={12} className={styles.sliderSkeleton}>
                <Skeleton variant="rect" width="20%" height={400} />
                <Skeleton variant="rect" width="20%" height={400} />
                <Skeleton variant="rect" width="20%" height={400} />
                <Skeleton variant="rect" width="20%" height={400} />
                <Skeleton variant="rect" width="20%" height={400} />
              </Grid>
            </Grid>
          ))}
        </>
      ) : (
        <>
          <Grid container spacing={3} className={styles.wrapper}>
            <Grid item xs={12} lg={4}>
              <Skeleton variant="rect" width="100%" height={330} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={5}>
              <Skeleton variant="rect" width={480} height={26} />
              <Skeleton variant="text" width={150} height={26} />
              <Skeleton variant="rect" width={480} height={120} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={3}>
              <Skeleton variant="rect" width={280} height={182} />
              <Skeleton variant="rect" width={280} height={50} />
            </Grid>
          </Grid>
          <Grid container spacing={3} className={styles.wrapper}>
            <Grid item xs={12} lg={1}>
              <Skeleton variant="text" width="100%" height={26} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={11}>
              <Skeleton variant="text" width={80} height={26} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={6}>
              <Skeleton variant="rect" width="100%" height={320} />
            </Grid>
            <Grid item className={styles.rightGrid} xs={12} lg={6}>
              <Skeleton variant="rect" width="100%" height={320} />
            </Grid>
          </Grid>
          <div className={styles.skeleTonWrapper}>
            <Skeleton variant="rect" width="100%" height={500} />
          </div>
        </>
      )}
    </Container>
  );
}
